<template>
  <!-- Expired Pass View - Shown when the pass is completed/expired -->
  <div
    class="bg-white rounded-30 d-flex flex-column justify-content-between align-items-center m-3"
  >
    <!-- Comments section -->
    <PassCommentsList :comments="comments" />

    <!-- Timer component for expired passes - displays total pass time -->
    <PassTimer
      :active-pass="activePass"
      :time-in-pass="timeInPass"
      :current-status="currentStatus"
      :is-pass-long-running="isPassLongRunning"
      :pin-attempts-count="pinAttemptsCount"
    />
  </div>
</template>

<script>
import PassCommentsList from "./PassCommentsList.vue"
import PassTimer from "./PassTimer.vue"

export default {
  name: "ExpiredPassView"
}
</script>

<script setup>
defineProps({
  activePass: {
    type: Object,
    default: () => ({})
  },
  comments: {
    type: Array,
    default: () => []
  },
  timeInPass: {
    type: String,
    default: ""
  },
  currentStatus: {
    type: String,
    default: ""
  },
  isPassLongRunning: {
    type: Boolean,
    default: false
  },
  pinAttemptsCount: {
    type: Number,
    default: 0
  }
})
</script>
